export default __webpack_public_path__ + "static/media/chevron-down.inline.07135701.svg";